import styled from 'styled-components';
import { COLORS } from '../../../../styles/variables';
import { AlphaTheme } from '../../../../../design-system/ThemeProvider/alphaTheme';

export const PriceCopy = styled.h4<{ isBold?: boolean; smallFont?: boolean; color?: string }>`
  margin: 0;
  font-family: 'Audi Type';
  letter-spacing: 0.001px;
  font-size: ${(props) => (props.smallFont ? '16px' : '18px')};
  line-height: 24px;
  font-weight: ${(props) => (props.isBold ? '700' : '400')};
  color: ${({ color, theme }: { color?: string; theme: Partial<AlphaTheme> }) => color || (theme.foregroundNeutral100 ?? COLORS.grey80)};
`;

export const PaymentsWrapper = styled.div<{ columnGap: number }>`
  display: flex;
  padding-bottom: 8px;
  gap: ${({ columnGap }) => (columnGap ? `${columnGap}px` : '16px')};
`;

export const PaymentsItem = styled.div`
  padding-top: 2px;
  padding-bottom: 2px;
  display: flex;
  flex-direction: column;
`;

export const PricingOptionsWrapper = styled.div`
  flex: 1;
`;

export const ExpiryDetails = styled.div<{ marginTop?: string }>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-top: 12px;
`;

export const Divider = styled.div`
  width: 1px;
  background-color: ${COLORS.grey15};
`;

export const PaymentsTileContainer = styled.div`
  display: flex;
  justify-content: center;
`;

export const OfferDescriptions = styled.div`
  max-height: 164px;
  overflow-y: auto;
`;

export const ExpiryTextWrapper = styled.div``;

export const OfferDetailsCTAWrapper = styled.div`
  flex-shrink: 0;
  white-space: nowrap;
`;
